import script from "./InputText.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputText.vue?vue&type=script&lang=ts&setup=true"

import "./InputText.vue?vue&type=style&index=0&id=8f4cbcd4&lang=less"

const __exports__ = script;

export default __exports__